import { Sun } from '../../../../icons';
import { WidgetCard } from '../WidgetCard';
import { useWidgetChrome } from '../widget-chrome';
import { useWidgetActions } from '../widget-context';
import { useWidgetItems } from '../use-widget-items';
import { WeatherPanel, type WeatherItemKey } from '../../../../components/Weather/WeatherPanel';
import { useWeatherPlace } from '../../../../components/Weather/useWeatherPlace';

/**
 * 날씨 위젯 (2026-09-21 · 시안 v4 확정).
 *
 * ★★★ 고정 줄(`WeatherPanel variant="strip"`)과 **같은 부품**을 쓴다 — 겉모양만 다르다.
 *      상태 판정은 `useWeatherPlace`, 문구는 `lib/weather-location.ts`, 값 해석은 `lib/weather-view.ts`.
 *      위젯용 문구를 새로 쓰지 않는다(그러면 같은 뜻이 두 글자가 된다).
 * ★★ 「어디 날씨」는 **그 자리의 설정**이다(`settings.weatherPlace`) — 같은 위젯을 두 자리에 놓고
 *     서로 다른 사업장을 볼 수 있다. 기본값은 **내 사업장, 없으면 회사**(서버가 정한다).
 * ★ 「보이는 항목」을 끄면 그리지 않을 뿐 아니라 **부르지도 않는다** — 시간별 예보를 끄면 단기예보를
 *   받지 않는다(공유 한도를 아낀다).
 */

const ITEM_KEYS: readonly WeatherItemKey[] = ['feels', 'humidity', 'pop', 'wind', 'hours'];

export function WeatherWidget() {
  const chrome = useWidgetChrome();
  const items = useWidgetItems('weather');
  const { go } = useWidgetActions();

  const shown = ITEM_KEYS.filter((k) => items.has(k));
  const { state, reload, canEditAddress } = useWeatherPlace({
    place: typeof chrome.settings.weatherPlace === 'string' ? chrome.settings.weatherPlace : undefined,
    items: shown,
  });

  return (
    <WidgetCard
      title="날씨"
      icon={Sun}
      // 지역 이름은 «늘» 보인다 — 사람마다 다른 값이라 안 적으면 옆자리와 견주다 오해한다(시안 v4).
      tail={state.kind === 'ready' ? state.regionName : undefined}
    >
      <WeatherPanel
        variant="widget"
        state={state}
        items={shown}
        canEditAddress={canEditAddress}
        onOpenCompany={() => go('/settings')}
        onRetry={reload}
      />
    </WidgetCard>
  );
}
